import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/desktop/panther_1440x532.webp")